import api from './index';

export interface ChatImageAttachment {
  mimeType: string;
  data: string;
}

export async function sendMessage(
  message: string,
  conversationId: string = 'default',
  userId?: string,
  previousUserMessage?: string,
  images?: ChatImageAttachment[],
  signal?: AbortSignal,
  editFromTurn?: number
) {
  try {
    const headers: Record<string,string> = {};
    if (userId) headers['x-user-id'] = String(userId);
    const res = await api.post('/chat', { 
      message, 
      conversationId,
      ...(userId && { userId }),
      ...(previousUserMessage && { previousUserMessage }),
      ...(images?.length ? { images } : {}),
      ...(typeof editFromTurn === 'number' ? { editFromTurn } : {})
    }, { headers, timeout: 90000, signal });
    return res.data;
  } catch (err: any) {
    if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError' || signal?.aborted) {
      return { success: false, cancelled: true };
    }
    const backendMessage = err?.response?.data?.message || err?.response?.data?.reply;
    console.error('chat api error', err);

    return {
      success: false,
      reply: backendMessage || 'Sorry — the chat service is currently unavailable. You can still browse the site or visit the Contact page to get in touch.'
    };
  }
}

